import api from "../index";

export const UploadDocumentApi = (data, headers) => api.post('UserAddKyc/Upload-Document', data, headers);
export const CheckKycStatusApi = (params) => api.get(`UserAddKyc/GetKYC-Status?${params}`);